import React from "react";
import { makeStyles } from "@material-ui/styles";
import HomeIcon from "@material-ui/icons/Home";
import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles({
  button: {
    backgroundColor: "#216174",
    borderRadius: 15,
    color: "#FFF",
    // color: "#216174",
    height: 32,
    width: 32,
    marginLeft: 25,
  },
});

const HomeIconButton = (props) => {
  const classes = useStyles();
  return (
    <IconButton area-label="home" className={classes.button} onClick={() => props.onClick()}>
      <HomeIcon fontSize="small" />
    </IconButton>
  );
};
export default HomeIconButton;
